import { render, staticRenderFns } from "./overview-data.vue?vue&type=template&id=49164472&scoped=true&"
import script from "./overview-data.vue?vue&type=script&lang=ts&"
export * from "./overview-data.vue?vue&type=script&lang=ts&"
import style0 from "./overview-data.vue?vue&type=style&index=0&id=49164472&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49164472",
  null
  
)

export default component.exports